import datetimeFormats from './config/dateTime';

export default defineI18nConfig(() => ({
	datetimeFormats,
	fallbackLocale: 'en',
}));
